import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, GridItem, Button } from '@deal/components'
import styles from './styles.css'

const MeetTheExperts: React.SFC = () => {
  return (
    <Grid className={styles.meetTheExperts}>
      <GridItem col={2} className={styles.wrapper}>
        <div className={styles.copyWrapper}>
          <div>
            Shopping with an expert means free personalized advice, unbiased recommendations, and
            really good deals.
          </div>
          <div className={styles.emphasis}>
            Whatever you’re looking for, we’ll find it together.
          </div>
          <div className={styles.action}>
            <Link to="/meet-the-experts">
              <Button variant="secondary-outline" className={styles.button}>
                Meet the experts
              </Button>
            </Link>
          </div>
        </div>
      </GridItem>
    </Grid>
  )
}

export default MeetTheExperts
